// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «CRM» (CRM, ключ `crm`, група `relationship-management`). */
export const crmManifest: IModuleManifest = {
  key: 'crm',
  group: 'relationship-management',
  slug: 'crm',
  prefix: 'CRM',
  name: { en: 'CRM', uk: 'CRM' },
  entities: [
    { key: 'crm', slug: 'crm', name: { en: 'Accounts', uk: 'Акаунти' }, main: true },
    { key: 'cnt', slug: 'cnt', name: { en: 'Contacts', uk: 'Контакти' }, main: false },
    { key: 'org', slug: 'org', name: { en: 'Organisations', uk: 'Організації' }, main: false },
    { key: 'iac', slug: 'iac', name: { en: 'Interactions', uk: 'Взаємодії' }, main: false },
    { key: 'seg', slug: 'seg', name: { en: 'Segments', uk: 'Сегменти' }, main: false },
    { key: 'contact_role', slug: 'contact-role', name: { en: 'Contact Roles', uk: 'Ролі' }, main: false },
    { key: 'contact_interaction', slug: 'contact-interaction', name: { en: 'Contact Interactions', uk: 'Взаємодії' }, main: false },
    { key: 'contact_consent', slug: 'contact-consent', name: { en: 'Contact Consents', uk: 'Згоди' }, main: false },
    { key: 'contact_address', slug: 'contact-address', name: { en: 'Contact Addresses', uk: 'Адреси' }, main: false },
    { key: 'contact_segment', slug: 'contact-segment', name: { en: 'Contact Segments', uk: 'Сегменти' }, main: false },
    { key: 'contact_status', slug: 'contact-status', name: { en: 'Contact Statuses', uk: 'Статуси' }, main: false },
  ],
  loadState: () => import('./state/crmSlice').then((m) => m.crmSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
